import { createApi } from "@reduxjs/toolkit/dist/query/react";
import { transformSucessResponse, transformErrorResponse } from "../../utils/API/responseMiddleware";
import { encryptQueryString } from "../../utils/API/requestMiddleware";
// import { defautBaseQuery } from '../../utils/API/fetchBaseQuery';
import { customFetchBase } from '../../utils/API/fetchBaseQuery';

const valueAPI = createApi({
    reducerPath: 'valueAPI',
    baseQuery: customFetchBase,
    endpoints: (builder) => ({

        getAllUsers: builder.query({
            query: () => ({
                url: encryptQueryString(`/User/GetAllUsers`),
                method: 'GET',
            }),
            transformResponse: transformSucessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

    })
})

export const { useLazyGetAllUsersQuery } = valueAPI;

export default valueAPI;